import { render, staticRenderFns } from "./ProjectProposalLifecycleSetter.vue?vue&type=template&id=a2d206ca"
import script from "./ProjectProposalLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectProposalLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports